import { Request } from '@/core/api/request'

class GenerateSettingsRequest extends Request {
  URL = '/spiders/generate-settings/'

  send({ id }) {
    return this.axios.post(this.URL, { source: id })
  }
}

export { GenerateSettingsRequest }
